module.exports = "/_next/static/images/PrezzeeBusinessLogo-2b19b1fe88797514e88e26c1678862f2.svg";